<script setup lang="ts">
</script>

<template>
    <!-- # Begin DGA block:complianceLinks -->
    <div class="compliance-links">
        <slot name="top" />
        <div class="compliance-links__wrapper">
            <slot name="prepend" />
            <span class="compliance-links__text">
                18+
            </span>
            <NuxtLink
                href="https://www.gamstop.co.uk/"
                target="_blank"
                external
                class="compliance-links__text compliance-links__text--footer"
            >
                Gamstop
            </NuxtLink>
            -
            <NuxtLink
                href="https://www.gamblingcommission.gov.uk/"
                target="_blank"
                external
                class="compliance-links__text compliance-links__text--footer"
            >
                Gambling Commission
            </NuxtLink>
            -
            <NuxtLink
                :to="{ name: 'safer-gambling' }"
                target="_blank"
                class="compliance-links__text compliance-links__text--footer"
            >
                Play responsibly
            </NuxtLink>
            -
            <NuxtLink
                href="https://www.gamblingtherapy.org/"
                target="_blank"
                external
                class="compliance-links__text compliance-links__text--footer"
            >
                Gambling Therapy
            </NuxtLink>
            -
            <NuxtLink
                href="https://www.gamcare.org.uk/talk-to-us-now/"
                target="_blank"
                external
                class="compliance-links__text compliance-links__text--footer"
            >
                The National Gambling Helpline
            </NuxtLink>
            -
            <NuxtLink
                href="tel:0808 8020 133"
                target="_blank"
                external
                class="compliance-links__text compliance-links__text--footer"
            >
                (0808 8020 133)
            </NuxtLink>
            <slot name="append" />
        </div>
        <slot name="bottom" />
    </div>
    <!-- # End DGA block -->
</template>

<style scoped lang="scss">
.compliance-links {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 12px;
    font-size: $font-size-xxs - 1;

    @include tablet() {
        font-size: $font-size-xxs;
    }

    &__wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        margin-top: 12px;

        :first-child {
            border-left: unset;
        }
    }

    &__text {
        margin: 0 5px;
        padding-bottom: 2px;
        line-height: 1.1;
        opacity: 0.7;
        color: inherit;

        @include tablet() {
            margin-top: 0;
        }
    }

    :deep(img) {
        width: auto;
        max-height: 24px;
    }

    a {
        color: inherit;
        text-decoration: underline;

        &:first-child {
            margin: 0;
        }
    }
}
</style>
